import {
  BoardMembersOutline,
  ExecutiveOutline,
} from '@simplywallst/ui-core/icons';
import { Role } from './styled';

interface Props {
  boardTitle?: string;
  teamTitle?: string;
}

const RolesWithTitles = ({ teamTitle, boardTitle }: Props) => {
  return (
    <>
      {teamTitle && (
        <Role>
          <ExecutiveOutline /> {teamTitle}
        </Role>
      )}
      {boardTitle && (
        <Role>
          <BoardMembersOutline /> {boardTitle}
        </Role>
      )}
    </>
  );
};

export default RolesWithTitles;
